import  useBookingState, {bookingInProgress, rescheduleInProgress, B_ACTIONS}            
                                                        from './bookingReducer'

/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

const BookingSideBarActions = ({eventDispatch, state}) => {
    
    const [bookingState, bookingUpdater] = useBookingState(state, eventDispatch)
    
    const handleClick = e => {
        e.preventDefault()
        bookingUpdater( B_ACTIONS.MENU_TASK_CLICK )
    }
    
    const active = true
    
    return <ul>
        { bookingInProgress( bookingState )? 
        <li key={'mtc'} className={'sideMenuLink ' + (active? 'active': '') } >
            <a href='.' onClick={handleClick} className='sideMenuLink-anchor' >Complete Booking</a>
        </li>: '' }
        { rescheduleInProgress( bookingState )? 
        <li key={'mtc'} className={'sideMenuLink ' + (active? 'active': '') } >
            <a href='.' onClick={handleClick} className='sideMenuLink-anchor' >Complete Reschedule</a>
        </li>: ''}
        </ul>
}

export default BookingSideBarActions


